import type * as registerWin32Icons16px from './registerWin32Icons16px';
import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule16px: LazyModule<typeof registerWin32Icons16px> = new LazyModule(
    () => import(/* webpackChunkName: "Win32Icons16px" */ './registerWin32Icons16px'),
    { name: 'Win32Icons16px' }
);

export const lazyRegisterWin32Icons16px: LazyAction<
    typeof registerWin32Icons16px.registerWin32Icons16px,
    typeof lazyModule16px
> = new LazyAction(lazyModule16px, module => module.registerWin32Icons16px);
